import { FetchProps } from 'helpers/redial'
import { runInAction } from 'mobx'
import { sanitizeQueryParams } from 'store/features/urlManager/helpers'

export default {
  fetch: async ({ store, query }: FetchProps) => {
    const { brandOverviewPage } = store

    if (query.category) {
      await store.user.setGenderByCategoryId(query.category, {
        enforceOnClient: true,
      })
    }

    return Promise.all([
      store.brandOverviewPage.fetchBrandRecommendations(),
      brandOverviewPage.fetchBrandsList(),
      brandOverviewPage.fetchHeroSliderImagesOnce(),
    ])
  },

  defer: async ({ store, service, query }: FetchProps) => {
    const sanitizedQuery = sanitizeQueryParams(query)
    const { gender } = store.user

    if (
      gender !== 'kids' &&
      store.brandOverviewPage.topBrandIdsByGender[gender].length === 0
    ) {
      const topBrands = await service.brands.requestRecommendedByGender(
        store.user.gender,
      )

      runInAction(() => {
        store.brandOverviewPage.topBrandIdsByGender = {
          ...store.brandOverviewPage.topBrandIdsByGender,
          [gender]: topBrands.map(brand => brand.id),
        }
      })
    }

    switch (sanitizedQuery.notification) {
      case '1':
        store.brandOverviewPage.triggerUnavailableNotification()
        break
      default:
    }
  },
}
